import { getParamsOptions, getParamsQueryKey } from "@/client/@tanstack/react-query.gen"
import { readCache } from "@/store/action"

const keys = [
  'errors',
] as const;

type ParamKey = typeof keys[number];
type Params = Record<ParamKey, any>;

//Params
export const getParams = () => {
  return readCache<any, Params>(getParamsQueryKey({
    path: {
      ids: keys as any,
    }
  }))
}
export const useParamsOptions = () => {
  return getParamsOptions({
    path: {
      ids: keys as any,
    }
  })
}
